import React from "react";
import Helmet from "react-helmet";
import { graphql } from "gatsby";
import Layout from "../layout";
import PostListing from "../components/PostListing";
import config from "../../data/SiteConfig";
import PageCover from "../components/PageCover";

export default class TagTemplate extends React.Component {
  render() {
    const { tag } = this.props.pageContext;
    const postEdges = this.props.data.content.edges;
    const lastEdges = this.props.data.last.edges[0];

    return (
      <Layout
        location={this.props.location}
        title={`Tagged in ${tag.charAt(0).toUpperCase() + tag.slice(1)}`}
        colorSet="OverviewPage"
      >
        <div className="tag-container">
          <Helmet>
            <title>{`مطالب نوشته شده با موضوع "${tag}" | ${config.siteTitle}`}</title>
            <link rel="canonical" href={`${config.siteUrl}${config.pathPrefix}/keyword/${tag}`} />
          </Helmet>
          <PageCover lastEdges={lastEdges.node.frontmatter.pageCover} />
          <div className="Article-header Article--fix jCenter">
            <h3 className="Article-title" itemProp="name">‍‍‍‍‍{' '}</h3>
          </div>
          <PostListing postEdges={postEdges} />
        </div>
      </Layout>
    );
  }
}

export const pageQuery = graphql`
  query ($tag: String) {
    content: allMarkdownRemark(
      limit: 1000
      sort: { fields: [fields___date], order: DESC }
      filter: { frontmatter: { tags: { in: [$tag] } } }
    ) {
      totalCount
      edges {
        node {
          fields {
            slug
            date
          }
          excerpt
          timeToRead
          frontmatter {
            title
            description
            tags
            category
            categoryTitle
            categoryColor
            date
          }
        }
      }
    }
    last: allMarkdownRemark(
      limit: 2
      sort: { fields: [fields___date], order: DESC }
      filter: { frontmatter: { tags: { in: [$tag] } } }
    ) {
      edges {
        node {
          fields {
            slug
            date
          }
          frontmatter {
            pageCover
          }
        }
      }
    }
  }
`;
